var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FormHandler } from '@unitarius/xbpm-runtime';
import { injector } from './injector';
import { FormLayout } from '../components/FormLayout';
import { baseControls } from '../components/form-controls';
import { baseContainers } from '../components/form-containers';
export var FORM_CONTROLS_TOKEN = Symbol('FORM_CONTROLS');
export var FORM_CONTAINERS_TOKEN = Symbol('FORM_CONTAINERS');
export var FORM_LAYOUT_TOKEN = Symbol('FORM_LAYOUT');
export var FORM_HANDLER_CONSTRUCTOR_TOKEN = Symbol('FORM_HANDLER_CONSTRUCTOR_TOKEN');
export var FORM_HANDLER_FACTORY_TOKEN = Symbol('FORM_HANDLER_FACTORY');
// base elements factories
injector.bind(FORM_CONTROLS_TOKEN).toConstantValue(baseControls);
injector.bind(FORM_CONTAINERS_TOKEN).toConstantValue(baseContainers);
injector.bind(FORM_LAYOUT_TOKEN).toConstantValue(FormLayout);
injector.bind(FORM_HANDLER_CONSTRUCTOR_TOKEN).toConstructor(FormHandler);
injector.bind(FORM_HANDLER_FACTORY_TOKEN).toFactory(function () { return function () {
    var Handler = injector.get(FORM_HANDLER_CONSTRUCTOR_TOKEN);
    return new Handler(injector.get(FORM_CONTROLS_TOKEN), injector.get(FORM_CONTAINERS_TOKEN), injector.get(FORM_LAYOUT_TOKEN));
}; });
// custom elements factories
var customControls = {};
var customContainers = {};
var setCustomFactory = function (baseFactories, customFactories, token) { return function (kind, factory) {
    if (factory) {
        customFactories[kind] = factory;
    }
    else {
        delete customFactories[kind];
    }
    injector.rebind(token).toConstantValue(__assign(__assign({}, baseFactories), customFactories));
}; };
export var setCustomControlFactory = setCustomFactory(baseControls, customControls, FORM_CONTROLS_TOKEN);
export var setCustomContainerFactory = setCustomFactory(baseContainers, customContainers, FORM_CONTAINERS_TOKEN);
//# sourceMappingURL=form.js.map